<a>
  <span ng-bind-html="match.model.displayName | uibTypeaheadHighlight:query"></span>
  <span class="second-column">{{match.model.description}}</span>
</a>
